export const authenticationRoutePaths = {
  /** Primary-outlet forbidden page for signed-in users; unauthenticated flows use `signIn` on the `top` outlet. */
  unauthorised: '/auth/403',
  signIn: '/auth/(top:sign-in)',
  ssoAuth: '/auth/(top:sso-auth)',
  forgotPassword: '/auth/(top:forgot-password)',
  contactUs: '/auth/(top:contact-us)',
  /**
   * Password reset deep link (top outlet). Matches `authentication.routes` `forgotten-password/:linkTypeId/:linkId`.
   */
  forgottenPassword(linkTypeId: string, linkId: string): string {
    const enc = encodeURIComponent;
    return `/auth/(top:forgotten-password/${enc(linkTypeId)}/${enc(linkId)})`;
  }
};
